document.addEventListener('DOMContentLoaded', function () {
  var galleryTrack = document.getElementById('gallery-mobile-track');
  var gallerySlides = Array.from(document.querySelectorAll('.gallery-slide'));
  var galleryThumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  var galleryCurrentIndex = document.getElementById('gallery-current-index');
  var galleryMainImg = document.getElementById('gallery-main-img');
  var desktopVariantMedia = document.getElementById('desktop-variant-media');
  var galleryPrev = document.getElementById('gallery-prev');
  var galleryNext = document.getElementById('gallery-next');
  var headerMenu = document.querySelector('.header-menu');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavCloseControls = Array.from(document.querySelectorAll('[data-mobile-nav-close]'));
  var mobileNavLinks = Array.from(document.querySelectorAll('.mobile-nav a'));

  var jarOptions = Array.from(document.querySelectorAll('.jar-option'));
  var autoRefillToggle = document.getElementById('auto-refill-toggle');
  var autoRefillTitle = document.getElementById('auto-refill-title');
  var autoRefillSub = document.querySelector('.auto-refill__sub');

  var addToCartBtn = document.getElementById('add-to-cart');
  var checkoutCtas = Array.from(document.querySelectorAll('[data-checkout-cta]'));
  var defaultCheckoutRoutesApi = {
    CHECKOUT_URLS: {
      oneTime: {
        buy1: '/cart/42548904001611:1',
        buy1Get1: '/cart/42548904034379:1',
        buy2Get2: '/cart/42548904067147:1'
      },
      subscription: {
  buy1: '/cart/42548904001611:1?selling_plan=1907064967',
  buy1Get1: '/cart/42548904034379:1?selling_plan=1907064967',
  buy2Get2: '/cart/42548904067147:1?selling_plan=1907064967'
}
    },
    normalizeVariantKey: function () {
      return 'FIXED';
    },
    resolveCheckoutUrl: function (purchaseType, bundleKey) {
      var bundleAliases = {
        buy1: 'buy1',
        buy1Get1: 'buy1Get1',
        buy1get1free: 'buy1Get1',
        buy2Get2: 'buy2Get2',
        buy2get2free: 'buy2Get2'
      };
      var normalizedPurchaseType = purchaseType === 'one_time' ? 'oneTime' : purchaseType;
      normalizedPurchaseType = defaultCheckoutRoutesApi.CHECKOUT_URLS[normalizedPurchaseType] ? normalizedPurchaseType : 'oneTime';

      var normalizedBundle = bundleAliases[bundleKey] || 'buy1';
      return defaultCheckoutRoutesApi.CHECKOUT_URLS[normalizedPurchaseType][normalizedBundle]
        || defaultCheckoutRoutesApi.CHECKOUT_URLS.oneTime.buy1;
    },
    resolveVariantId: function () {
      return '';
    }
  };
  function hasCheckoutResolver(config) {
    return Boolean(config && typeof config.resolveCheckoutUrl === 'function');
  }

  function hasPricingResolver(config) {
    return Boolean(config && typeof config.resolveBundlePricing === 'function');
  }

  function resolveCheckoutConfig() {
    var candidateConfigs = [
      window.LulabitesCheckoutRoutes,
      window.SnoozeBrewCheckoutRoutes,
      defaultCheckoutRoutesApi
    ];

    var fullyFeaturedConfig = candidateConfigs.find(function (config) {
      return hasCheckoutResolver(config) && hasPricingResolver(config);
    });

    if (fullyFeaturedConfig) {
      return fullyFeaturedConfig;
    }

    return candidateConfigs.find(function (config) {
      return hasCheckoutResolver(config);
    }) || defaultCheckoutRoutesApi;
  }

  var checkoutRoutes = resolveCheckoutConfig();
  var trackingApi = window.SnoozeBrewAbTracking;
  var runtimeConfig = window.SnoozeBrewRuntimeConfig || {};
  var abDebugLoggingEnabled = Boolean(runtimeConfig.abDebugLogging);
  var headlineTestKey = runtimeConfig.headlineTestKey || 'snooze_brew_headline_v1';
  var headlineTrackingEndpoint = runtimeConfig.abDashboardEndpoint || 'https://funnel-ab-dashboard.vercel.app/api/ab-track';
  var supabaseHeadlineConfig = runtimeConfig.supabase || {};
  var requiresHeadlineReady = Boolean(
    supabaseHeadlineConfig.url && supabaseHeadlineConfig.publishableKey
  );
  var headlineElement = document.querySelector('[data-ab-headline]');
  var defaultHeadlineText = headlineElement && headlineElement.textContent
    ? headlineElement.textContent.trim()
    : 'Snooze Brew™ Magnesium Sleep Aid';
  var fallbackHeadlineVariants = [
    {
      variant_key: 'A',
      headline: defaultHeadlineText,
      subheadline: '',
      is_control: true
    },
    {
      variant_key: 'B',
      headline: 'Fall Asleep Faster Without Waking Up Groggy',
      subheadline: '',
      is_control: false
    }
  ];
  var tracker = trackingApi && typeof trackingApi.createAbTracker === 'function'
    ? trackingApi.createAbTracker({
      endpoint: headlineTrackingEndpoint,
      testKey: headlineTestKey
    })
    : null;
  var headlineExperimentReady = Promise.resolve(null);
  var activeHeadlineAssignment = null;
  var pageVariantKey = '';

  var accordionItems = document.querySelectorAll('[data-accordion]');
  var faqItems = document.querySelectorAll('[data-faq]');
  var seeAllBtn = document.getElementById('see-all-btn');
  var modal = document.getElementById('ingredients-modal');
  var modalClose = document.getElementById('modal-close');

  var resultsSlides = Array.from(document.querySelectorAll('.result-slide'));
  var avatarBtns = Array.from(document.querySelectorAll('.avatar-btn'));
  var dotsContainer = document.getElementById('carousel-dots');
  var dots = Array.from(dotsContainer ? dotsContainer.querySelectorAll('.dot') : []);
  var prevBtn = document.getElementById('results-prev');
  var nextBtn = document.getElementById('results-next');
  var resultsViewport = document.querySelector('.results-viewport');
  var benefitStrip = document.getElementById('benefit-strip');

  var videoThumbs = Array.from(document.querySelectorAll('.video-thumb, .media-play-tile'));
  var reviewThumbnailVideos = Array.from(document.querySelectorAll('.reviews-showcase__thumb video'));
  var isiOSDevice = /iP(ad|hone|od)/.test(window.navigator.userAgent) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  var ingredientsRow = document.getElementById('ingredients-row');
  var ingredientsPrev = document.getElementById('ingredients-prev');
  var ingredientsNext = document.getElementById('ingredients-next');

  var selectedOption = jarOptions.find(function (option) {
    return option.classList.contains('selected');
  }) || jarOptions[0] || null;
  var jarToBundle = {
    '1': 'buy1',
    '2': 'buy1Get1',
    '3': 'buy2Get2'
  };
  var pricingVariantKey = 'FIXED';

  if (addToCartBtn && checkoutCtas.indexOf(addToCartBtn) === -1) {
    checkoutCtas.push(addToCartBtn);
  }

  function logAbDebug(level) {
    if (!abDebugLoggingEnabled || !window || !window.console || typeof window.console[level] !== 'function') {
      return;
    }

    window.console[level].apply(window.console, Array.prototype.slice.call(arguments, 1));
  }

  function logAbVariant() {
    if (!window || !window.console || typeof window.console.info !== 'function') {
      return;
    }

    window.console.info.apply(window.console, Array.prototype.slice.call(arguments));
  }

  function markPricingReady() {
    if (document && document.documentElement && document.documentElement.classList) {
      document.documentElement.classList.remove('pricing-pending');
    }
  }

  function publishHeadlineDebugState(assignment, metadata) {
    if (!assignment || !window) {
      return;
    }

    var debugState = {
      test_key: headlineTestKey,
      variant_key: assignment.variant_key || 'A',
      headline: assignment.headline || defaultHeadlineText,
      is_control: Boolean(assignment.is_control)
    };

    if (metadata && typeof metadata === 'object') {
      Object.keys(metadata).forEach(function (key) {
        debugState[key] = metadata[key];
      });
    }

    window.SnoozeHeadlineAbState = debugState;

    logAbVariant('[Snooze AB] ' + headlineTestKey + ' resolved to variant ' + debugState.variant_key, debugState);
  }

  function getActiveHeadlineVariantKey() {
    return activeHeadlineAssignment && activeHeadlineAssignment.variant_key
      ? activeHeadlineAssignment.variant_key
      : 'A';
  }

  function applyHeadlineText(text) {
    if (!headlineElement || typeof text !== 'string') {
      return;
    }

    var nextText = text.trim();

    if (!nextText) {
      return;
    }

    headlineElement.textContent = nextText;
  }

  function buildRandomHeadlineVariantKey() {
    return Math.random() < 0.5 ? 'A' : 'B';
  }

  function resolvePageVariantKey() {
    pageVariantKey = buildRandomHeadlineVariantKey();
    return pageVariantKey;
  }

  function applyHeadlineAssignment(variantDefinition, source) {
    if (!variantDefinition) {
      return null;
    }

    activeHeadlineAssignment = {
      variant_key: variantDefinition.variant_key,
      headline: variantDefinition.headline,
      subheadline: variantDefinition.subheadline || '',
      is_control: Boolean(variantDefinition.is_control)
    };

    applyHeadlineText(activeHeadlineAssignment.headline);
    publishHeadlineDebugState(activeHeadlineAssignment, {
      source: source
    });

    return activeHeadlineAssignment;
  }

  function chooseVariantDefinition(variants, preferredVariantKey) {
    if (!variants.length) {
      return null;
    }

    var preferredVariant = variants.find(function (variant) {
      return variant.variant_key === preferredVariantKey;
    });

    if (preferredVariant) {
      return preferredVariant;
    }

    if (variants.length === 1) {
      return variants[0];
    }

    return variants[Math.floor(Math.random() * variants.length)] || variants[0];
  }

  function normalizeVariantDefinition(variant) {
    if (!variant || typeof variant !== 'object') {
      return null;
    }

    var normalizedVariantKey = typeof variant.variant_key === 'string'
      ? variant.variant_key.trim().toUpperCase()
      : '';
    var normalizedHeadline = typeof variant.headline === 'string'
      ? variant.headline.trim()
      : '';

    if (!normalizedVariantKey || !normalizedHeadline) {
      return null;
    }

    return {
      variant_key: normalizedVariantKey,
      headline: normalizedHeadline,
      subheadline: typeof variant.subheadline === 'string' ? variant.subheadline.trim() : '',
      is_control: Boolean(variant.is_control)
    };
  }

  function fetchSupabaseHeadlineVariants() {
    if (!window.fetch || !supabaseHeadlineConfig.url || !supabaseHeadlineConfig.publishableKey) {
      return Promise.resolve(null);
    }

    var requestUrl = supabaseHeadlineConfig.url
      + '/rest/v1/ab_tests?select=id,test_key,status,ab_variants(variant_key,headline,subheadline,is_control)'
      + '&test_key=eq.' + encodeURIComponent(headlineTestKey)
      + '&status=eq.active&limit=1';

    return window.fetch(requestUrl, {
      method: 'GET',
      headers: {
        apikey: supabaseHeadlineConfig.publishableKey
      }
    }).then(function (response) {
      if (!response || response.ok === false || typeof response.json !== 'function') {
        return null;
      }

      return response.json();
    }).then(function (payload) {
      var testRecord = Array.isArray(payload) ? payload[0] : payload;
      var remoteVariants = testRecord && Array.isArray(testRecord.ab_variants)
        ? testRecord.ab_variants.map(normalizeVariantDefinition).filter(Boolean)
        : [];

      return remoteVariants.length ? remoteVariants : null;
    }).catch(function () {
      return null;
    });
  }

  function buildFallbackHeadlineAssignment(preferredVariantKey) {
    var variantDefinition = chooseVariantDefinition(fallbackHeadlineVariants, preferredVariantKey);

    if (!variantDefinition) {
      return {
        variant_key: preferredVariantKey || 'A',
        headline: defaultHeadlineText,
        subheadline: '',
        is_control: true
      };
    }

    return variantDefinition;
  }

  function resolveHeadlineAssignment() {
    var selectedVariantKey = pageVariantKey || resolvePageVariantKey();
    var fallbackAssignment = applyHeadlineAssignment(
      buildFallbackHeadlineAssignment(selectedVariantKey),
      'random'
    );

    return fetchSupabaseHeadlineVariants().then(function (remoteVariants) {
      var remoteAssignment = chooseVariantDefinition(remoteVariants || [], selectedVariantKey);

      if (!remoteAssignment) {
        return fallbackAssignment;
      }

      return applyHeadlineAssignment(remoteAssignment, 'supabase');
    }).catch(function () {
      return fallbackAssignment;
    });
  }

  function formatPrice(value) {
    var amount = Number(value);

    if (!isFinite(amount)) {
      return '';
    }

    return '$' + amount.toFixed(2);
  }

  function parseAmount(value) {
    if (value === '' || value === null || typeof value === 'undefined') {
      return null;
    }

    var amount = Number(value);
    return isFinite(amount) ? amount : null;
  }

  function applyDiscount(amount, discountPercent) {
    var numericAmount = parseAmount(amount);
    var numericDiscount = parseAmount(discountPercent);

    if (numericAmount === null) {
      return '';
    }

    if (numericDiscount === null) {
      return numericAmount;
    }

    return numericAmount * (1 - numericDiscount / 100);
  }

  function getSubscriptionDiscountPercent() {
    var sourceOption = selectedOption || jarOptions[0];
    var discountValue = sourceOption ? parseAmount(sourceOption.dataset.discount) : null;
    return discountValue === null ? 0 : discountValue;
  }

  function getPurchaseType() {
    if (!autoRefillToggle) {
      return 'subscription';
    }

    return autoRefillToggle.checked ? 'subscription' : 'oneTime';
  }

  function resolvePricingVariantAssignment() {
    pricingVariantKey = checkoutRoutes && typeof checkoutRoutes.normalizeVariantKey === 'function'
      ? checkoutRoutes.normalizeVariantKey()
      : 'FIXED';
    window.SnoozePricingAbState = {
      variant_key: pricingVariantKey,
      source: 'fixed_pricing'
    };

    return pricingVariantKey;
  }

  function getPricingForOption(option, purchaseType) {
    var isSubscription = purchaseType === 'subscription';
    var currentPrice = parseAmount(isSubscription ? option.dataset.subscription : option.dataset.regular);
    var comparePrice = parseAmount(isSubscription ? option.dataset.subscriptionCompare : option.dataset.regularCompare);
    var dailyPrice = parseAmount(isSubscription ? option.dataset.subscriptionDaily : option.dataset.regularDaily);

    if (currentPrice !== null || comparePrice !== null || dailyPrice !== null) {
      return {
        current: currentPrice !== null ? currentPrice : 0,
        compare: comparePrice,
        daily: dailyPrice
      };
    }

    return {
      current: purchaseType === 'subscription' ? 24.95 : 34.95,
      compare: purchaseType === 'subscription' ? 34.95 : null,
      daily: purchaseType === 'subscription' ? 0.83 : 1.17
    };
  }

  function getSelectedBundleKey() {
  var currentSelectedOption = jarOptions.find(function (option) {
    return option.classList.contains('selected');
  }) || selectedOption;

  if (!currentSelectedOption) {
    return 'buy1';
  }

  var bundleAliases = {
    buy1: 'buy1',
    buy1Get1: 'buy1Get1',
    buy1get1free: 'buy1Get1',
    buy2Get2: 'buy2Get2',
    buy2get2free: 'buy2Get2'
  };

  var rawBundleKey = currentSelectedOption.dataset.bundle || jarToBundle[currentSelectedOption.dataset.jar] || 'buy1';

  return bundleAliases[rawBundleKey] || 'buy1';
}

  function getCheckoutUrl() {
    var purchaseType = getPurchaseType();
    var bundleKey = getSelectedBundleKey();
 
    if (!bundleKey || !checkoutRoutes || typeof checkoutRoutes.resolveCheckoutUrl !== 'function') {
      return '';
    }

    return checkoutRoutes.resolveCheckoutUrl(purchaseType, bundleKey);
  }

  function syncCheckoutCtas() {
    var purchaseType = getPurchaseType();
    var bundleKey = getSelectedBundleKey();
    var checkoutUrl = getCheckoutUrl();

    checkoutCtas.forEach(function (cta) {
      cta.dataset.checkoutUrl = checkoutUrl;
      cta.dataset.purchaseType = purchaseType;
      cta.dataset.bundle = bundleKey || '';
      cta.dataset.option = bundleKey || '';

      if (cta.tagName && cta.tagName.toLowerCase() === 'a') {
        cta.href = checkoutUrl;
      }
    });
  }

  function trackCheckoutClick(checkoutUrl, purchaseType, bundleKey) {
    if (!tracker) {
      return Promise.resolve(null);
    }

    var trackPromise = typeof tracker.trackEvent === 'function'
      ? tracker.trackEvent('cta_click', {
        variant: getActiveHeadlineVariantKey(),
        metadata: {
          checkout_url: checkoutUrl,
          purchase_type: purchaseType,
          bundle: bundleKey
        }
      })
      : typeof tracker.track === 'function'
        ? Promise.resolve(tracker.track('cta_click', {
          metadata: {
            checkout_url: checkoutUrl,
            purchase_type: purchaseType,
            bundle: bundleKey
          }
        }))
        : Promise.resolve(null);

    return trackPromise.then(function (result) {
      if (result && result.queued === false) {
        logAbDebug('error', '[Snooze AB] cta_click tracking failed or was blocked', result);
      }

      return result;
    }).catch(function (error) {
      logAbDebug('error', '[Snooze AB] cta_click tracking threw an error', error);

      return { queued: false };
    });
  }

  function openMobileNav() {
    if (!mobileNav) {
      return;
    }

    mobileNav.hidden = false;
    document.body.classList.add('mobile-nav-open');

    if (headerMenu) {
      headerMenu.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileNav() {
    if (!mobileNav) {
      return;
    }

    mobileNav.hidden = true;
    document.body.classList.remove('mobile-nav-open');

    if (headerMenu) {
      headerMenu.setAttribute('aria-expanded', 'false');
    }
  }

  function updateGalleryUI(index) {
    if (!gallerySlides.length || !galleryThumbs.length) {
      return;
    }

    gallerySlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    galleryThumbs.forEach(function (thumb, thumbIndex) {
      thumb.classList.toggle('active', thumbIndex === index);
      thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
    });

    if (galleryCurrentIndex) {
      galleryCurrentIndex.textContent = String(index + 1);
    }
  }

  function goToGalleryIndex(index, behavior) {
    if (!galleryTrack || !gallerySlides.length) {
      return;
    }

    var safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));
    var slideWidth = galleryTrack.clientWidth;

    galleryTrack.scrollTo({
      left: safeIndex * slideWidth,
      behavior: behavior || 'smooth'
    });

    updateGalleryUI(safeIndex);
  }

  function syncGalleryFromScroll() {
    if (!galleryTrack || !gallerySlides.length) {
      return;
    }

    var slideWidth = galleryTrack.clientWidth || 1;
    var index = Math.round(galleryTrack.scrollLeft / slideWidth);
    updateGalleryUI(index);
  }

  function updateVariantMedia(imageSrc) {
    if (desktopVariantMedia) {
      desktopVariantMedia.src = imageSrc;
    }
  }

  function renderJarPricing() {
    var useSubscription = autoRefillToggle ? autoRefillToggle.checked : true;
    var purchaseType = useSubscription ? 'subscription' : 'one_time';

    jarOptions.forEach(function (option) {
      var current = option.querySelector('.price-current');
      var compare = option.querySelector('.price-compare');
      var daily = option.querySelector('.price-daily');
      var pricing = getPricingForOption(option, purchaseType);
      var comparePrice = parseAmount(pricing.compare);
      var dailyPrice = parseAmount(pricing.daily);

      if (current) {
        current.textContent = formatPrice(pricing.current);
      }

      if (compare) {
        if (comparePrice !== null) {
          compare.textContent = formatPrice(comparePrice);
          compare.style.display = 'inline-block';
        } else {
          compare.textContent = '';
          compare.style.display = 'none';
        }
      }

      if (daily) {
        if (dailyPrice && formatPrice(dailyPrice)) {
          daily.textContent = formatPrice(dailyPrice) + ' per day';
          daily.style.display = 'block';
        } else {
          daily.textContent = '';
          daily.style.display = 'none';
        }
      }
    });

    if (autoRefillTitle) {
      autoRefillTitle.textContent = useSubscription
        ? 'Save ' + getSubscriptionDiscountPercent() + '% with Monthly Delivery'
        : 'One-Time Purchase';
    }

    if (autoRefillSub) {
      autoRefillSub.textContent = useSubscription ? 'Cancel Anytime \u2013 No Commitment' : 'No automatic refills';
    }

    if (selectedOption) {
      updateVariantMedia(selectedOption.dataset.image);
    }

    syncCheckoutCtas();
    markPricingReady();
  }

  function setSelectedOption(option) {
    selectedOption = option;

    jarOptions.forEach(function (item) {
      var isSelected = item === option;
      item.classList.toggle('selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    renderJarPricing();
    goToGalleryIndex(0, 'smooth');
  }

  jarOptions.forEach(function (option) {
    option.setAttribute('aria-pressed', option.classList.contains('selected') ? 'true' : 'false');
    option.addEventListener('click', function () {
      setSelectedOption(option);
    });
  });

  if (autoRefillToggle) {
    autoRefillToggle.addEventListener('change', renderJarPricing);
  }

  resolvePricingVariantAssignment();
  renderJarPricing();

  headlineExperimentReady = resolveHeadlineAssignment().finally(function () {
    if (tracker) {
      tracker.trackEvent('page_view', {
        variant: getActiveHeadlineVariantKey()
      }).then(function (result) {
        if (window) {
          window.SnoozeHeadlineAbTrackingState = result || { queued: false };
        }

        if (result && result.queued === false) {
          logAbDebug('error', '[Snooze AB] page_view tracking failed or was blocked', result);
          return;
        }

        logAbDebug('info', '[Snooze AB] page_view tracking sent', result || { queued: true });
      }).catch(function () {
        return null;
      });
    }
  });

  if (headerMenu && mobileNav) {
    headerMenu.addEventListener('click', function () {
      if (mobileNav.hidden) {
        openMobileNav();
      } else {
        closeMobileNav();
      }
    });
  }

  mobileNavCloseControls.forEach(function (control) {
    control.addEventListener('click', closeMobileNav);
  });

  mobileNavLinks.forEach(function (link) {
    link.addEventListener('click', closeMobileNav);
  });

  if (galleryTrack) {
    galleryTrack.addEventListener('scroll', syncGalleryFromScroll, { passive: true });
  }

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goToGalleryIndex(Number(thumb.dataset.index), 'smooth');
    });
  });

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function () {
      var activeIndex = gallerySlides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      goToGalleryIndex(Math.max(0, activeIndex - 1), 'smooth');
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', function () {
      var activeIndex = gallerySlides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      goToGalleryIndex(Math.min(gallerySlides.length - 1, activeIndex + 1), 'smooth');
    });
  }

  window.addEventListener('resize', function () {
    syncGalleryFromScroll();

    if (window.innerWidth > 1024) {
      closeMobileNav();
    }
  });

  updateGalleryUI(0);

  function handleCheckoutCtaClick(event) {
  var cta = event.currentTarget || event.target || addToCartBtn || this;
  var purchaseType = '';
  var bundleKey = '';
  var checkoutUrl = '';

  if (!cta || cta.disabled) {
    return;
  }

  event.preventDefault();
  syncCheckoutCtas();

  purchaseType = autoRefillToggle && autoRefillToggle.checked ? 'subscription' : 'oneTime';
  console.log('autoRefillToggle checked:', autoRefillToggle && autoRefillToggle.checked);
console.log('purchaseType:', purchaseType);
console.log('bundleKey:', bundleKey);
  bundleKey = getSelectedBundleKey();
  checkoutUrl = getCheckoutUrl();

  if (!checkoutUrl) {
    return;
  }

  function goToCheckout() {
    var variantIds = {
      buy1: 42548904001611,
      buy1Get1: 42548904034379,
      buy2Get2: 42548904067147
    };

    var item = {
      id: variantIds[bundleKey],
      quantity: 1
    };

    if (!item.id) {
      window.location.href = checkoutUrl;
      return Promise.resolve();
    }

    if (autoRefillToggle && autoRefillToggle.checked) {
  item.selling_plan = 1878360139;
}

    console.log('Adding item to cart:', item);

return fetch('/cart/clear.js', { method: 'POST' })
  .then(function () {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
  })
  .then(function (response) {
    if (!response.ok) {
      return response.text().then(function (text) {
        console.error('Cart add failed:', response.status, text);
        alert('Cart add failed. Check console for details.');
        throw new Error(text);
      });
    }

    return response.json();
  })
  .then(function (cartResponse) {
    console.log('Cart add success:', cartResponse);
    window.location.href = '/checkout';
  })
  .catch(function (error) {
    console.error('Checkout redirect stopped:', error);
  });
  }

  if (!requiresHeadlineReady) {
    syncCheckoutCtas();
    trackCheckoutClick(checkoutUrl, purchaseType, bundleKey).finally(goToCheckout);
    return;
  }

  headlineExperimentReady.finally(function () {
    syncCheckoutCtas();
    trackCheckoutClick(checkoutUrl, purchaseType, bundleKey).finally(goToCheckout);
  });
}

checkoutCtas.forEach(function (cta) {
  cta.addEventListener('click', handleCheckoutCtaClick);
});

  accordionItems.forEach(function (item) {
    var header = item.querySelector('.accordion-header');
    var body = item.querySelector('.accordion-body');
    var icon = item.querySelector('.accordion-icon');

    if (!header || !body) {
      return;
    }

    header.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');

      item.classList.toggle('open', !isOpen);
      body.style.display = isOpen ? 'none' : 'block';
      header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      if (icon) {
        icon.textContent = isOpen ? '+' : '\u2212';
      }
    });
  });

  faqItems.forEach(function (item) {
    var question = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');

    if (!question || !answer) {
      return;
    }

    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      answer.style.display = isOpen ? 'none' : 'block';
    });
  });

  if (seeAllBtn && modal) {
    seeAllBtn.addEventListener('click', function () {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }

  if (modalClose && modal) {
    modalClose.addEventListener('click', function () {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    if (mobileNav && !mobileNav.hidden) {
      closeMobileNav();
    }

    if (modal && modal.style.display === 'flex') {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  function getResultsCardsPerPage() {
    if (window.innerWidth <= 768) {
      return 1;
    }

    return 2;
  }

  function getResultsMaxPage() {
    return Math.max(0, resultsSlides.length - getResultsCardsPerPage());
  }

  function syncResultDots() {
    if (!dotsContainer) {
      return;
    }

    var requiredDots = getResultsMaxPage() + 1;
    var dotMarkup = '';
    var dotIndex = 0;

    for (dotIndex = 0; dotIndex < requiredDots; dotIndex += 1) {
      dotMarkup += '<span class="dot' + (dotIndex === 0 ? ' active' : '') + '" data-dot="' + dotIndex + '"></span>';
    }

    dotsContainer.innerHTML = dotMarkup;
    dots = Array.from(dotsContainer.querySelectorAll('.dot'));
  }

  function setActiveResultAvatar(index) {
    avatarBtns.forEach(function (btn, btnIndex) {
      btn.classList.toggle('active', btnIndex === index);
    });
  }

  function setActiveResultDot(index) {
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('active', dotIndex === index);
    });
  }

  function showResultSlide(index, activeAvatarIndex) {
    if (!resultsSlides.length || !resultsViewport) {
      return 0;
    }

    var safePage = Math.max(0, Math.min(index, getResultsMaxPage()));
    var slidesTrack = document.getElementById('results-slides');
    var targetSlide = resultsSlides[safePage];
    var maxTranslate = Math.max(0, slidesTrack.scrollWidth - resultsViewport.clientWidth);
    var translateX = targetSlide ? Math.min(targetSlide.offsetLeft, maxTranslate) : 0;

    slidesTrack.style.transform = 'translateX(-' + translateX + 'px)';

    resultsSlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('active', slideIndex === (activeAvatarIndex != null ? activeAvatarIndex : safePage));
    });

    setActiveResultAvatar(activeAvatarIndex != null ? activeAvatarIndex : safePage);
    setActiveResultDot(safePage);

    return safePage;
  }

  var currentResultSlide = 0;
  var currentActiveAvatar = 0;

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      currentResultSlide = currentResultSlide <= 0 ? getResultsMaxPage() : currentResultSlide - 1;
      currentActiveAvatar = currentResultSlide;
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
      currentActiveAvatar = currentResultSlide;
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  avatarBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var avatarIndex = Number(btn.dataset.slide);
      currentActiveAvatar = avatarIndex;
      currentResultSlide = Math.min(avatarIndex, getResultsMaxPage());
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  });

  if (dotsContainer) {
    dotsContainer.addEventListener('click', function (event) {
      var dot = event.target.closest('.dot');

      if (!dot) {
        return;
      }

      currentResultSlide = Number(dot.dataset.dot);
      currentActiveAvatar = Math.min(currentResultSlide, resultsSlides.length - 1);
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  var resultsAutoplay = window.setInterval(function () {
    currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
    currentActiveAvatar = currentResultSlide;
    showResultSlide(currentResultSlide, currentActiveAvatar);
  }, 6500);

  var resultsCarousel = document.getElementById('results-carousel');
  if (resultsCarousel) {
    resultsCarousel.addEventListener('mouseenter', function () {
      window.clearInterval(resultsAutoplay);
    });

    resultsCarousel.addEventListener('mouseleave', function () {
      window.clearInterval(resultsAutoplay);
      resultsAutoplay = window.setInterval(function () {
        currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
        currentActiveAvatar = currentResultSlide;
        showResultSlide(currentResultSlide, currentActiveAvatar);
      }, 6500);
    });
  }

  window.addEventListener('resize', function () {
    syncResultDots();
    currentResultSlide = Math.min(currentResultSlide, getResultsMaxPage());
    currentActiveAvatar = Math.min(currentActiveAvatar, resultsSlides.length - 1);
    showResultSlide(currentResultSlide, currentActiveAvatar);
  });

  syncResultDots();
  showResultSlide(0, 0);

  function makeVideoInlineSafe(video) {
    if (!video) {
      return;
    }

    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;

    if (video.hasAttribute('muted')) {
      video.muted = true;
    }
  }

  function primeVideoFrame(video, seekTime) {
    var thumbnailPrimed = false;

    if (!video) {
      return;
    }

    makeVideoInlineSafe(video);
    video.preload = video.hasAttribute('autoplay') ? 'auto' : 'metadata';

    function primeThumbnail() {
      if (thumbnailPrimed || !Number.isFinite(video.duration)) {
        return;
      }

      thumbnailPrimed = true;

      try {
        video.currentTime = Math.min(seekTime, Math.max(video.duration - 0.1, 0));
      } catch (error) {
        return;
      }
    }

    if (video.readyState >= 2) {
      primeThumbnail();
    } else {
      video.addEventListener('loadeddata', primeThumbnail, { once: true });
    }
  }

  function shouldUseIOSPosterLock(thumb) {
    return Boolean(isiOSDevice && thumb && thumb.closest('#product-info, #social-section'));
  }

  function applyIOSPosterLock(thumb, video) {
    var poster = video && video.getAttribute('poster');

    if (!shouldUseIOSPosterLock(thumb) || !poster) {
      return false;
    }

    thumb.classList.add('ios-poster-lock');
    thumb.style.backgroundImage = 'url("' + poster.replace(/"/g, '\\"') + '")';
    video.preload = 'none';
    return true;
  }

  videoThumbs.forEach(function (thumb) {
    var video = thumb.querySelector('video');
    var hasIOSPosterLock = false;

    if (!video) {
      return;
    }

    hasIOSPosterLock = applyIOSPosterLock(thumb, video);

    if (!hasIOSPosterLock) {
      primeVideoFrame(video, 0.1);
    }

    thumb.addEventListener('click', function () {
      var isPlaying = !video.paused;

      videoThumbs.forEach(function (otherThumb) {
        var otherVideo = otherThumb.querySelector('video');
        if (otherVideo && otherVideo !== video) {
          otherVideo.pause();
          otherThumb.classList.remove('is-playing');
          otherThumb.classList.remove('is-playback-blocked');
          otherVideo.controls = false;
        }
      });

      if (isPlaying) {
        video.pause();
        thumb.classList.remove('is-playing');
      } else {
        thumb.classList.remove('is-playback-blocked');
        if (hasIOSPosterLock) {
          thumb.classList.add('is-playing');
        }
        video.controls = false;
        video.removeAttribute('muted');
        video.muted = false;
        var playAttempt = null;

        try {
          playAttempt = video.play();
        } catch (error) {
          video.controls = true;
          thumb.classList.add('is-playback-blocked');
          thumb.classList.remove('is-playing');
          return;
        }

        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {
            video.controls = true;
            thumb.classList.add('is-playback-blocked');
            thumb.classList.remove('is-playing');
          });
        } else {
          thumb.classList.add('is-playing');
        }

        if (playAttempt && typeof playAttempt.then === 'function') {
          playAttempt.then(function () {
            video.controls = false;
            thumb.classList.remove('is-playback-blocked');
          }).catch(function () {
            return null;
          });
        } else {
          video.controls = false;
          thumb.classList.remove('is-playback-blocked');
          thumb.classList.add('is-playing');
        }
      }
    });

    video.addEventListener('pause', function () {
      thumb.classList.remove('is-playing');
    });

    video.addEventListener('play', function () {
      thumb.classList.add('is-playing');
    });
  });

  reviewThumbnailVideos.forEach(function (video) {
    video.pause();
    video.muted = true;
    video.setAttribute('muted', '');
    primeVideoFrame(video, 0.6);
  });

  if (ingredientsRow) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    function getIngredientsScrollAmount() {
      var firstCard = ingredientsRow.querySelector('.ingredient-card');
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 168;
      return Math.max(cardWidth + 16, ingredientsRow.clientWidth * 0.72);
    }

    function updateIngredientsArrows() {
      var maxScroll = Math.max(0, ingredientsRow.scrollWidth - ingredientsRow.clientWidth - 2);

      if (ingredientsPrev) {
        ingredientsPrev.disabled = ingredientsRow.scrollLeft <= 2;
      }

      if (ingredientsNext) {
        ingredientsNext.disabled = ingredientsRow.scrollLeft >= maxScroll;
      }
    }

    function scrollIngredients(direction) {
      ingredientsRow.scrollBy({
        left: getIngredientsScrollAmount() * direction,
        behavior: 'smooth'
      });
    }

    if (ingredientsPrev) {
      ingredientsPrev.addEventListener('click', function () {
        scrollIngredients(-1);
      });
    }

    if (ingredientsNext) {
      ingredientsNext.addEventListener('click', function () {
        scrollIngredients(1);
      });
    }

    ingredientsRow.addEventListener('mousedown', function (event) {
      isDown = true;
      startX = event.pageX - ingredientsRow.offsetLeft;
      scrollLeft = ingredientsRow.scrollLeft;
      ingredientsRow.style.cursor = 'grabbing';
    });

    ingredientsRow.addEventListener('mouseleave', function () {
      isDown = false;
      ingredientsRow.style.cursor = '';
    });

    ingredientsRow.addEventListener('mouseup', function () {
      isDown = false;
      ingredientsRow.style.cursor = '';
    });

    ingredientsRow.addEventListener('mousemove', function (event) {
      if (!isDown) {
        return;
      }

      event.preventDefault();
      var x = event.pageX - ingredientsRow.offsetLeft;
      var walk = (x - startX) * 2;
      ingredientsRow.scrollLeft = scrollLeft - walk;
    });

    ingredientsRow.addEventListener('scroll', updateIngredientsArrows, { passive: true });
    window.addEventListener('resize', updateIngredientsArrows);
    window.requestAnimationFrame(updateIngredientsArrows);
  }

  if (benefitStrip) {
    var benefitStripHovered = false;
    var benefitStripInView = false;

    function syncBenefitStripState(isInView) {
      benefitStripInView = Boolean(isInView);
      benefitStrip.classList.toggle('is-animating', benefitStripInView && !benefitStripHovered);
      benefitStrip.classList.toggle('is-paused', benefitStripHovered);
      benefitStrip.dataset.inView = benefitStripInView ? 'true' : 'false';
    }

    function updateBenefitStripVisibility() {
      var rect = benefitStrip.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      var isInView = visibleHeight > Math.min(rect.height * 0.15, 80);

      syncBenefitStripState(isInView);
    }

    benefitStrip.addEventListener('mouseenter', function () {
      benefitStripHovered = true;
      syncBenefitStripState(benefitStripInView);
    });

    benefitStrip.addEventListener('mouseleave', function () {
      benefitStripHovered = false;
      syncBenefitStripState(benefitStripInView);
    });

    if ('IntersectionObserver' in window) {
      var benefitStripObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isInView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          syncBenefitStripState(isInView);
        });
      }, {
        threshold: 0.15
      });

      benefitStripObserver.observe(benefitStrip);
    }

    window.addEventListener('scroll', updateBenefitStripVisibility, { passive: true });
    window.addEventListener('resize', updateBenefitStripVisibility);
    window.requestAnimationFrame(updateBenefitStripVisibility);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      var target = null;

      if (!href || href === '#') {
        event.preventDefault();
        return;
      }

      try {
        target = document.querySelector(href);
      } catch (error) {
        target = null;
      }

      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
